// Selector to get the current theme from the state
import { StoreState } from "../types/StoreState";

const getTheme = (state: StoreState): string => {
  return state.coreState.theme;
};

export default getTheme;
